import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { easeOutExpo } from '../utils/motion';

/**
 * Brand glyph: an apron hanging over a pan, drawn in one hairline weight.
 * The strokes draw themselves once on load, then hold still.
 */
export function BrandMark({
  className
}: {
  className?: string;
}) {
  const reduce = useReducedMotion();
  const draw = (delay: number) => reduce ? {
    initial: {
      pathLength: 1,
      opacity: 1
    },
    animate: {
      pathLength: 1,
      opacity: 1
    }
  } : {
    initial: {
      pathLength: 0,
      opacity: 0
    },
    animate: {
      pathLength: 1,
      opacity: 1
    },
    transition: {
      duration: 0.26,
      delay,
      ease: easeOutExpo
    }
  };
  return <svg viewBox="0 0 32 32" className={className} fill="none" stroke="currentColor" strokeWidth={1.9} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-2" data-mp="17jn1iozvp2hn">
      {/* pan bowl + rim */}
      <motion.path d="M5.5 17.5h17" {...draw(0.02)} data-id="element-3" data-mp="206g7bls4kryi" />
      <motion.path d="M6.5 17.5v1a8 8 0 0 0 15 0v-1" {...draw(0.06)} data-id="element-4" data-mp="13uxjmv4g2bnd" />
      {/* handle */}
      <motion.path d="M22.5 18.2 29 19.6" {...draw(0.12)} data-id="element-5" data-mp="18usawzs4t38y" />
      {/* apron bib */}
      <motion.path d="M11.4 17.4 12.6 10.4" {...draw(0.16)} data-id="element-6" data-mp="u5e33w47etvo" />
      <motion.path d="M16.6 17.4 15.4 10.4" {...draw(0.18)} data-id="element-7" data-mp="u5481u4axwj4" />
      {/* neck loop */}
      <motion.path d="M12.6 10.4c0-2.6 1-3.9 1.4-3.9s1.4 1.3 1.4 3.9" {...draw(0.22)} data-id="element-8" data-mp="z36034jph66q" />
      {/* ties */}
      <motion.path d="M11.9 13.6 7.4 11.7" {...draw(0.26)} data-id="element-9" data-mp="l34sl68xr0ia" />
      <motion.path d="M16.1 13.6 20.6 11.7" {...draw(0.29)} data-id="element-10" data-mp="p6t1ptd7u45n" />
    </svg>;
}